import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import Text from '../../typography/Text';
import Icon from '../Icon';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Breadcrumbs');
var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "arrowRightRaw",
  size: "raw",
  color: "currentColor"
});
function Breadcrumbs(_ref) {
  let {
    classes: classesProp,
    overrides: overridesProp,
    className: classNameProp,
    onClick,
    items,
    ...props
  } = _ref;
  const classes = useClasses(useStyles, classesProp);

  // Overrides
  const override = getOverrides(overridesProp, Breadcrumbs.overrides);

  // Classes
  const rootClassName = classnames(classes.root, {
    [classes.clickables]: !!onClick
  }, classNameProp);
  const rootProps = {
    ...props,
    className: rootClassName
  };
  const onClickItem = useCallback(item => {
    onClick && onClick(item);
  }, [onClick]);
  const breadcrumbItems = useMemo(() => {
    if (!items) return null;
    return items.reduce((arr, item, idx) => {
      if (item) {
        const isLast = idx === items.length - 1;
        arr.push(/*#__PURE__*/React.createElement("div", _extends({
          key: item.id || idx,
          className: classes.item,
          onClick: isLast ? undefined : () => onClickItem(item)
        }, override.item), /*#__PURE__*/React.createElement(Text, override.Text, item.text)));
      }
      if (idx < items.length - 1) {
        arr.push(/*#__PURE__*/React.createElement("div", _extends({
          key: `divider-${idx}`,
          className: classes.divider
        }, override.item, override.divider), _ref2));
      }
      return arr;
    }, []);
  }, [classes.divider, classes.item, items, onClickItem, override.Text, override.divider, override.item]);
  return /*#__PURE__*/React.createElement("div", _extends({}, rootProps, override.root), breadcrumbItems);
}
Breadcrumbs.overrides = ['root', 'item', 'divider'];
process.env.NODE_ENV !== "production" ? Breadcrumbs.propTypes = {
  /** Custom CSS class for styling the breadcrumbs container */
  className: PropTypes.string,
  /** Object with custom style overrides for inner elements */
  overrides: PropTypes.object,
  /** Function called when a breadcrumb item is clicked, receives the item object */
  onClick: PropTypes.func,
  /** Array of items to display in the breadcrumb trail */
  items: PropTypes.arrayOf(PropTypes.shape({
    /** Unique identifier for the breadcrumb item */
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** Text displayed for the breadcrumb item */
    text: PropTypes.string.isRequired
  }))
} : void 0;
export default /*#__PURE__*/React.memo(Breadcrumbs);